import { Observable, Subject } from 'rxjs'
import { Container, IInit } from '../container/Container'
import { getAppContainer } from 'container/app'
import { STATUS_SERVICE_KEY } from 'container/app'

type Status = {
  variant: 'success' | 'error' | 'warning'
  message?: string // e.message()
  error?: Error
}

export interface IStatusService extends IInit {
  sendStatus(sts: Status): void

  statusObservable(): Observable<any>
}

export const useStatus = (): IStatusService => {
  return getAppContainer().get<IStatusService>(STATUS_SERVICE_KEY)
}

export class StatusService implements IStatusService {
  private readonly _status: Subject<Status>

  constructor() {
    this._status = new Subject<Status>()
  }

  init(c: Container): void {}

  sendStatus(sts: Status): void {
    this._status.next(sts)
  }

  statusObservable(): Observable<Status> {
    return this._status.pipe()
  }
}
